/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type AppSchemasV2TransactionCountListTransactionCountMeta = {
  totalTransactionsForDataset?: string | undefined;
  totalTransactionsForAllTime?: string | undefined;
};

/** @internal */
export const AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema:
  z.ZodType<
    AppSchemasV2TransactionCountListTransactionCountMeta,
    z.ZodTypeDef,
    unknown
  > = z.object({
    total_transactions_for_dataset: z.string().optional(),
    total_transactions_for_all_time: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "total_transactions_for_dataset": "totalTransactionsForDataset",
      "total_transactions_for_all_time": "totalTransactionsForAllTime",
    });
  });

/** @internal */
export type AppSchemasV2TransactionCountListTransactionCountMeta$Outbound = {
  total_transactions_for_dataset?: string | undefined;
  total_transactions_for_all_time?: string | undefined;
};

/** @internal */
export const AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema:
  z.ZodType<
    AppSchemasV2TransactionCountListTransactionCountMeta$Outbound,
    z.ZodTypeDef,
    AppSchemasV2TransactionCountListTransactionCountMeta
  > = z.object({
    totalTransactionsForDataset: z.string().optional(),
    totalTransactionsForAllTime: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      totalTransactionsForDataset: "total_transactions_for_dataset",
      totalTransactionsForAllTime: "total_transactions_for_all_time",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasV2TransactionCountListTransactionCountMeta$ {
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema` instead. */
  export const inboundSchema =
    AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema;
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema` instead. */
  export const outboundSchema =
    AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema;
  /** @deprecated use `AppSchemasV2TransactionCountListTransactionCountMeta$Outbound` instead. */
  export type Outbound =
    AppSchemasV2TransactionCountListTransactionCountMeta$Outbound;
}

export function appSchemasV2TransactionCountListTransactionCountMetaToJSON(
  appSchemasV2TransactionCountListTransactionCountMeta:
    AppSchemasV2TransactionCountListTransactionCountMeta,
): string {
  return JSON.stringify(
    AppSchemasV2TransactionCountListTransactionCountMeta$outboundSchema.parse(
      appSchemasV2TransactionCountListTransactionCountMeta,
    ),
  );
}

export function appSchemasV2TransactionCountListTransactionCountMetaFromJSON(
  jsonString: string,
): SafeParseResult<
  AppSchemasV2TransactionCountListTransactionCountMeta,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AppSchemasV2TransactionCountListTransactionCountMeta$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AppSchemasV2TransactionCountListTransactionCountMeta' from JSON`,
  );
}
